export const styles = {
  tableContainer: {
    borderRadius: '8px'
  },
  tableWrapper: {
    width: '100%',
    borderTop: '1px solid #373b3e',
    overflowX: 'auto' as const,
    marginBottom: '-6px'
  },
  pagination: {
    display: 'flex',
    gap: '8px',
    marginBottom: '20px',
    alignItems: 'center'
  },
  sortIcon: {
    marginLeft: '4px',
    display: 'inline-block'
  },
  pageButton: {
    minWidth: '31px',
    height: '31px',
    border: 'none',
    backgroundColor: 'transparent',
    color: '#fff',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.active': {
      backgroundColor: '#3b82f6'
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  },
  noData: {
    textAlign: 'center' as const,
    padding: '2rem',
    color: '#6c757d'
  }
};

export const scrollbarStyles = `
  .dark-table-container .table-wrapper::-webkit-scrollbar {
    height: 6px;
    margin-top: -6px;
  }

  .dark-table-container .table-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    cursor: pointer;
  }

  .dark-table-container .table-wrapper::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    cursor: pointer;
  }

  .dark-table-container .table-wrapper {
    margin-bottom: 0;
    cursor: pointer;
  }

  .dark-table-container .dark-table {
    margin-bottom: 0;
  }
`;
